import { Link } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";
import { Seo } from "@/components/Seo";
import { WHATSAPP_URL } from "@/lib/constants";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-spice-cream flex flex-col" data-testid="not-found-page">
      <Seo
        title="Page Not Found | Nandanaaya Spices"
        description="The page you are looking for is not available. Browse our wholesale spice products or send an enquiry."
        path="/404"
        noindex
      />
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-xl text-center space-y-5">
          <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Error 404</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-spice-ink">This page is not available</h1>
          <p className="text-sm text-spice-muted leading-relaxed">
            The link may be outdated or mistyped. You can browse our wholesale spice range, read about our supply
            process, or send your requirement for a current quotation.
          </p>
          <div className="flex flex-wrap justify-center gap-3 pt-2">
            <Link
              to="/products"
              data-testid="notfound-products-link"
              className="px-6 py-3 bg-spice-green text-white text-sm font-semibold rounded-[9px] hover:bg-spice-green-dark transition-colors"
            >
              View Products
            </Link>
            <Link
              to="/contact"
              data-testid="notfound-contact-link"
              className="px-6 py-3 bg-spice-sand text-spice-green text-sm font-semibold rounded-[9px] hover:bg-spice-line transition-colors"
            >
              Request Current Quote
            </Link>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Enquire on WhatsApp (opens WhatsApp in a new tab)"
              data-testid="notfound-whatsapp-link"
              className="px-6 py-3 border border-spice-line text-spice-green text-sm font-semibold rounded-[9px] hover:bg-white transition-colors"
            >
              Enquire on WhatsApp
            </a>
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
